var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.revision === 'pending')?_c('span',{staticClass:"text-xs italic"},[_vm._v(_vm._s(_vm.$t('messages.general.revision_pending')))]):_c('span',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }